module.exports = __webpack_public_path__ + "images/e6e55ec.svg";